<template>
  <div class="refundOrder">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="118px"
        :model="formInline"
        inline
      >
        <el-form-item prop="orderNumber" label="订单编号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.orderNumber"
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="学员手机号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.phone"
            placeholder="请输入学员手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="refundWay" label="退费方式">
          <el-select
            style="width: 290px"
            v-model="formInline.refundWay"
            placeholder="请选择退费方式"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="指定账号" value="2"></el-option>
            <el-option label="原路退回" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="insertByName" label="工单创建人">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.insertByName"
            placeholder="请输入工单创建人"
          ></el-input>
        </el-form-item>
        <el-form-item prop="nickname" label="学员昵称">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.nickname"
            placeholder="请输入学员昵称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="skuName" label="班级名称">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.skuName"
            placeholder="请输入班级名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="queryTime" label="申请退费时间">
          <my-datePicker
            width="290px"
            :scopeDate="formInline.queryTime"
            @receiveMyDate="queryTimeReceiveMyDate"
          />
        </el-form-item>
        <el-form-item prop="status" label="打款进度">
          <el-select
            style="width: 290px"
            v-model="formInline.status"
            placeholder="请选择打款进度"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="退费中" value="1"></el-option>
            <el-option label="已退费" value="2"></el-option>
            <el-option label="已取消退费" value="3"></el-option>
            <el-option label="打款失败" value="4"></el-option>
            <el-option label="已驳回" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!checkAdmin()"
          prop="pushStatus"
          label="是否推送到广电"
        >
          <el-select
            style="width: 290px"
            v-model="formInline.pushStatus"
            placeholder="请选择是否推送到广电"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未推送" value="1"></el-option>
            <el-option label="已推送" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="companyId" label="所属租户">
          <el-select
            style="width: 290px"
            v-model="formInline.companyId"
            placeholder="请选择"
          >
            <!-- <el-option label="全部" value="-1"></el-option> -->
            <el-option
              v-for="item in companyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="工单ID" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.id || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.orderNumber || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员昵称" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickname || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员手机号" minWidth="180" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="退费金额" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.refundAmt || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品（班级）名称" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.skuName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属租户" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退费原因" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.reason === 1">个人原因</el-tag>
            <el-tag type="danger" v-else-if="row.reason === 2">其他</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="退费方式" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.refundWay === 1">原路退回</el-tag>
            <el-tag type="danger" v-else-if="row.refundWay === 2"
              >指定账号</el-tag
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="申请退费日期" width="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!checkAdmin()" label="是否推送到广电" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <el-tag type="danger" v-if="row.pushStatus === 1">未推送</el-tag>
            <el-tag type="success" v-else-if="row.pushStatus === 2"
              >已推送</el-tag
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="工单备注" width="160" align="center">
          <template slot-scope="{ row }">
            <el-tooltip v-if="row.remarks" :offset="0" effect="light" :content="row.remarks" placement="top-end">
              <span class="lineClamp_box">{{ row.remarks }}</span>
            </el-tooltip>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="退费进度" width="160" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status === 1">退费中</el-tag>
            <el-tag v-else-if="row.status === 2" type="success">已打款</el-tag>
            <el-tag v-else-if="row.status === 3" type="info">已取消退费</el-tag>
            <el-tag v-else-if="row.status === 4" type="danger">打款失败</el-tag>
            <el-tag v-else-if="row.status === 5" type="warning">已驳回</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="工单创建人" width="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertByName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="260" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span
              class="blue_Box"
              v-if="
                [1, 2, 3].includes(row.status) &&
                $hasAuthority('app1_refund_detail')
              "
              @click="openCreateRefund('details', row)"
            >查看工单详情</span>
            <template v-if="$myStore.state.user.userIdentity !== 2">
              <span
                class="blue_Box"
                v-if="
                  [1, 4].includes(row.status) &&
                  $hasAuthority('app1_refund_dispose')
                "
                @click="openHandleRefund('handle', row)"
              >退费处理</span>
              <span
                class="blue_Box"
                v-if="
                  [1, 4, 5].includes(row.status) &&
                  $hasAuthority('app1_refund_cancel')
                "
                @click="handleCancel(row.id)"
              >取消退费</span>
            </template>
            <span
              class="blue_Box"
              v-if="
                row.status === 2 && $hasAuthority('app1_refund_dispose_detail')
              "
              @click="openHandleRefund('details', row)"
            >退费处理详情</span>
            <span
              class="blue_Box"
              v-if="row.status === 5 && $hasAuthority('app1_refund_reason')"
              @click="openCreateRefund('alter', row)"
            >查看驳回原因</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 查看工单详情、查看驳回原因 -->
    <CreateRefund ref="createRefundRef" />
    <!-- 退费处理、退费处理详情 -->
    <HandleRefund ref="handleRefundRef" />
  </div>
</template>

<script>
import {
  getRefundWorkDataListPage,
  cancelRefundWorkData,
} from "@/api/refund/refundOrder.js";
import { getSelectCompanyList } from "@/api/orderAdmin/orderList";
import { getAppUserInfo } from "@/api/common";
import myPagination from "@/components/myPagination.vue";
import myDatePicker from "@/components/myDatePicker.vue";
import CreateRefund from "@/views/refund/components/createRefund.vue";
import HandleRefund from "@/views/refund/components/handleRefund.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "RefundOrder",
  components: {
    myPagination,
    myDatePicker,
    CreateRefund,
    HandleRefund,
  },
  data() {
    return {
      loading: false,
      formInline: {
        orderNumber: "",
        phone: "",
        refundWay: "-1",
        insertByName: "",
        nickname: "",
        skuName: "",
        queryTime: [],
        queryStartTime: "",
        queryEndTime: "",
        companyId: "-1",
        status: "-1",
        pushStatus: "-1",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      companyData: [],
    };
  },
  mounted() {
    // this.getRefundWorkDataListPage({ page: 1, limit: 10 });
    this.getSelectCompanyList();
  },
  methods: {
    // 退费处理、退费处理详情
    openHandleRefund(status, payload) {
      this.$refs.handleRefundRef.init(status, payload);
    },
    // 查看工单详情、查看驳回原因
    openCreateRefund(status, payload) {
      this.$refs.createRefundRef.init(status, payload);
    },
    // 取消退费
    handleCancel(id) {
      this.$confirm("确认要取消该退费吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cancelRefundWorkData({ id }).then((res) => {
            if (res.code === 0) {
              this.refresh();
              this.$message({
                type: "success",
                message: "取消成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 租户列表
    getSelectCompanyList() {
      getSelectCompanyList().then((res) => {
        if (res.code === 0) {
          this.companyData = res.data || [];
          this.formInline.companyId = res.data[0]?.id;
          this.searchData.companyId = res.data[0]?.id;
          this.getRefundWorkDataListPage({
            page: 1,
            limit: 10,
            companyId: this.formInline.companyId,
          });
        }
      });
    },
    // 刷新
    refresh() {
      this.getRefundWorkDataListPage(
        Object.assign(clone(this.searchData), {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 列表请求
    async getRefundWorkDataListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      delete payload.queryTime;
      const res = await getRefundWorkDataListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 支付时间
    queryTimeReceiveMyDate(payload) {
      this.formInline.queryTime = payload;
      this.formInline.queryStartTime = payload[0] + " 00:00:00";
      this.formInline.queryEndTime = payload[1] + " 23:59:59";
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getRefundWorkDataListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.formInline.queryTime = [];
      this.formInline.queryStartTime = "";
      this.formInline.queryEndTime = "";
      this.$refs["formInline"].resetFields();
      this.getSelectCompanyList();
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getRefundWorkDataListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getRefundWorkDataListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.refundOrder {
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }

  .lineClamp_box {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
}
</style>
